import requestTool from './index.js'
const agreeProtocol = params => requestTool.gatewayApiPost(`/educational/cal/sxjmv3/activity/agree-protocol`, params, '/gatewayApi')
const answerStudentFace = params => requestTool.get(`/educational/cal/sxjmv3/activity/face?${new Date().getTime()}`, params, '/gatewayApi')
const getPaperInfo = params => requestTool.get(`/educational/cal/sxjmv3/answer/info?${new Date().getTime()}`, params, '/gatewayApi')
const submitQuestion = params => requestTool.gatewayApiPost(`/educational/cal/sxjmv3/answer/submit/question?${new Date().getTime()}`, params, '/gatewayApi')
const submitPaper = params => requestTool.gatewayApiPost(`/educational/cal/sxjmv3/answer/submit?${new Date().getTime()}`, params, '/gatewayApi')
const recordConnectNum = params => requestTool.get(`/educational/cal/sxjmv3/activity/monitors-exception?${new Date().getTime()}`, params, '/gatewayApi')
// const scoreQueryApi = params => requestTool.get(`/educational/sxjm/student/cal/v3-individual-score?${new Date().getTime()}`, params, '/gatewayApi')
const scoreQueryApi = params => requestTool.get(`/educational/sxjm/student/cal/v3-individual-score/v2?${new Date().getTime()}`, params, '/gatewayApi')
const studentScoreQueryApi = params => requestTool.get(`/educational/sxjm/student/cal/student-score?${new Date().getTime()}`, params, '/gatewayApi')
const getCertDownUrl = params => requestTool.get(`/educational/sxjm/student/cal/certificate-url/${params.certId}`, params, '/gatewayApi')
// const scoreQueryApi = params => requestTool.get(`http://10.4.68.18:8917/sxjm/student/cal/v3-individual-score?${new Date().getTime()}`, params, '/gatewayApi') // 新服务获取全国奖获取列表
const studentInfo = params => requestTool.gatewayApiPost(`/educational/cal/sxjmv3/activity/v3-student-info?${new Date().getTime()}`, params, '/gatewayApi')
const examCountDown = params => requestTool.get(`/educational/cal/sxjmv3/activity/count-down?${new Date().getTime()}`, params, '/gatewayApi')
const getBatchFileUrl = params => requestTool.get(`/educational/cal/sxjmv3/activity/certification-url?${new Date().getTime()}`, params, '/gatewayApi')
const groupList = params => requestTool.get(`/educational/sxjm/student/v3-group-list?${new Date().getTime()}`, params, '/gatewayApi')
// const groupList = params => requestTool.get(`http://10.4.68.18:8917/sxjm/student/v3-group-list?${new Date().getTime()}`, params, '/gatewayApi')
// const groupExport = params => requestTool.gatewayApiPost(`/educational/sxjm/student/v3-group-export?${new Date().getTime()}`, params, '/gatewayApi')
const groupExport = params => requestTool.gatewayApiPost(`/educational/sxjm/student/v3-group-export/v2?${new Date().getTime()}`, params, '/gatewayApi')
const getFileUrl = params => requestTool.get(`educational/rs/get-file-url?${new Date().getTime()}`, params, '/gatewayApi')
const paperDel = params => requestTool.gatewayApiPost(`/educational/sxjm/paper/del?${new Date().getTime()}`, params, '/gatewayApi')
const validIdentity = params => requestTool.gatewayApiPost(`/educational/cal/sxjmv3/activity/valid-identity/v2?${new Date().getTime()}`, params, '/gatewayApi')
const updateIdentity = params => requestTool.gatewayApiPost(`/educational/cal/sxjmv3/activity/identity-update?${new Date().getTime()}`, params, '/gatewayApi')
const getActivityDetailsPage = params => requestTool.get(`/educational/sxjm/activity/details/page?${new Date().getTime()}`, params, '/gatewayApi')
const getActivityDetail = params => requestTool.get(`/educational/cal/competition/${params.id}`, params, '/gatewayApi')

// 查询学生活动列表
const getStudentActivityList = params => requestTool.get(`/educational/cal/sxjmv3/activity/student-activity-list`, params, '/gatewayApi')
// 证书查验
const verifyCert = params => requestTool.gatewayApiPost(`/educational/sxjm/student/cal/verify-certificate`, params, '/gatewayApi')

// 查询证书邮寄信息
const getCertMailingInfo = params => requestTool.get(`/educational/sxjm/student/cal/receiving-address?${new Date().getTime()}`, params, '/gatewayApi')
// 保存证书邮寄信息
const saveCertMailingInfo = params => requestTool.gatewayApiPost(`/educational/sxjm/student/cal/receiving-address?${new Date().getTime()}`, params, '/gatewayApi')
// 省市区：parentId=1 查省，否则用当前节点 id 查下级
// 使用无 credentials 请求，避免跨域 Access-Control-Allow-Origin: * 与 withCredentials 冲突
const getSysAreaList = (parentId = 1) =>
  requestTool.getJsonData(`https://jsxfx-gateway.jsxfedu.com/upms/sysArea/list/${parentId}`).then((res) => {
    if (res && res.code === 0) return res.data || []
    return Promise.reject(res || { msg: '获取地区失败' })
  })

export default {
    agreeProtocol,
    answerStudentFace,
    groupList,
    getPaperInfo,
    submitQuestion,
    submitPaper,
    recordConnectNum,
    scoreQueryApi,
    studentScoreQueryApi,
    getCertDownUrl,
    studentInfo,
    examCountDown,
    getBatchFileUrl,
    groupExport,
    getFileUrl,
    paperDel,
    validIdentity,
    updateIdentity,
    getActivityDetailsPage,
    getActivityDetail,
    getStudentActivityList,
    verifyCert,
    getCertMailingInfo,
    saveCertMailingInfo,
    getSysAreaList,
}
